import { CategoryQuestions } from '../types';

export const selfLoveQuestions: CategoryQuestions = {
  title: 'Personalize Your Self-Love Session',
  questions: {
    preferredStyle: {
      label: 'What self-love practice resonates most with you?',
      type: 'radio',
      options: ['Positive affirmations and self-talk', 'Body appreciation and acceptance', 'Forgiveness and self-compassion', 'Celebrating personal strengths']
    },
    primaryGoal: {
      label: 'What aspect of self-love do you want to focus on?',
      type: 'radio',
      options: ['Dissolve negative self-talk', 'Build inner kindness', 'Increase self-acceptance', 'Strengthen emotional resilience']
    },
    specificFocus: {
      label: 'What self-doubt or criticism do you want to heal today?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  // Practitioner perspective questions
  practitionerTitle: 'Personalize Self-Love Session for Your Client',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What self-love practice resonates most with your client?',
      type: 'radio',
      options: ['Positive affirmations and self-talk', 'Body appreciation and acceptance', 'Forgiveness and self-compassion', 'Celebrating personal strengths']
    },
    primaryGoal: {
      label: 'What aspect of self-love does your client want to focus on?',
      type: 'radio',
      options: ['Dissolve negative self-talk', 'Build inner kindness', 'Increase self-acceptance', 'Strengthen emotional resilience']
    },
    specificFocus: {
      label: 'What self-doubt or criticism does your client want to heal today?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Self-Love Session for Your Clients',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'What self-love practice resonates most with your clients?',
      type: 'radio',
      options: ['Positive affirmations and self-talk', 'Body appreciation and acceptance', 'Forgiveness and self-compassion', 'Celebrating personal strengths']
    },
    primaryGoal: {
      label: 'What aspect of self-love do your clients want to focus on?',
      type: 'radio',
      options: ['Dissolve negative self-talk', 'Build inner kindness', 'Increase self-acceptance', 'Strengthen emotional resilience']
    },
    specificFocus: {
      label: 'What self-doubt or criticism do your clients want to heal today?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Self-Love Session',
  groupQuestions: {
    groupSelfLoveContext: {
      label: 'What type of group self-love session are you creating?',
      type: 'radio',
      options: ['Family building confidence together', 'Support group for self-esteem', 'Team building positive culture', 'Friends supporting each other', 'Workshop for self-acceptance', 'Healing circle for self-compassion']
    },
    groupSelfChallenges: {
      label: 'What self-love challenges does your group face together?',
      type: 'textarea',
      placeholder: 'Describe shared insecurities, negative patterns, or self-criticism issues...'
    },
    collectiveGoals: {
      label: 'What does your group want to achieve in self-love together?',
      type: 'radio',
      options: ['Build mutual support and encouragement', 'Practice self-compassion as a group', 'Celebrate each other\'s strengths', 'Heal shared experiences or trauma', 'Create positive group culture']
    },
    groupDynamics: {
      label: 'How does your group work best for self-love practices?',
      type: 'radio',
      options: ['Sharing affirmations with each other', 'Silent individual practice together', 'Taking turns offering encouragement', 'Collective affirmations for the group']
    },
    vulnerabilityLevel: {
      label: 'What level of emotional openness is comfortable for your group?',
      type: 'radio',
      options: ['Very open - deep sharing and vulnerability', 'Moderately open - some personal sharing', 'Gentle sharing - surface level comfort', 'Private practice - minimal sharing']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Self-Love Session for Your Loved One',
  giftQuestions: {
    // Using preferredStyle to match regular user questions - backend expects this field
    preferredStyle: {
      label: 'What self-love challenge are they facing?',
      type: 'radio',
      options: ['Low self-esteem or confidence', 'Negative self-talk', 'Body image issues', 'Difficulty accepting compliments', 'Perfectionism and self-criticism', 'Feeling unworthy of love']
    },
    // Using primaryGoal to match regular user questions - backend expects this field
    primaryGoal: {
      label: 'What would you like this session to help them with?',
      type: 'radio',
      options: ['Building self-confidence', 'Practicing self-compassion', 'Accepting themselves fully', 'Recognizing their worth', 'Silencing inner critic', 'Celebrating their strengths']
    },
    specificFocus: {
      label: 'What specific self-love topics should the session address?',
      type: 'textarea',
      placeholder: 'Optional - describe specific areas of self-criticism or low confidence...'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  }
};
